import { AxiosRequestHeaders } from 'axios';
import {
  KeyValueMap,
  EntryProps,
  PaginationQueryOptions,
  QueryParams,
} from '../../commonTypes';
import {
  CreateValueRangeProps,
  RestEndpoint,
  UpdateValueRangeProps,
} from './types';
import { AxiosInstance } from '../../commonTypes';
import * as raw from './raw';
import { DEFAULT_QUERY } from '../constants';

const BASE_URL = '/value-ranges';

export const get: RestEndpoint<'ValueRange', 'get'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  params: { id: string | number },
  headers?: AxiosRequestHeaders
) => {
  return raw.get<EntryProps<T> | null>(http, `${BASE_URL}/${params.id}`, {
    headers: { ...headers },
    params: {...DEFAULT_QUERY}
  });
};

export const getMany: RestEndpoint<'ValueRange', 'getMany'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  params: QueryParams<PaginationQueryOptions>,
  headers?: AxiosRequestHeaders
) => {
  return raw.get<EntryProps<T, true>>(http, `${BASE_URL}`, {
    headers: { ...headers },
    params: params.query,
  });
};

export const create: RestEndpoint<'ValueRange', 'create'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  rawData: CreateValueRangeProps,
  headers?: AxiosRequestHeaders
) => {
  return raw.post<EntryProps<T> | null>(http, `${BASE_URL}`, rawData, {
    headers: { ...headers },
  });
};

export const update: RestEndpoint<'ValueRange', 'update'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  params: { id: string | number },
  rawData: UpdateValueRangeProps,
  headers?: AxiosRequestHeaders
) => {
  return raw.put<EntryProps<T> | null>(
    http,
    `${BASE_URL}/${params.id}`,
    rawData,
    {
      headers: { ...headers },
    }
  );
};

export const del: RestEndpoint<'ValueRange', 'del'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  params: { id: string | number },
  headers?: AxiosRequestHeaders
) => {
  return raw.del<T>(http, `${BASE_URL}/${params.id}`, {
    headers: { ...headers },
  });
};
